import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <nav className="border-b border-gray-100 p-4 sticky top-0 bg-white/90 backdrop-blur z-10">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <span className="font-bold text-xl flex items-center gap-2">
            <span className="text-2xl">🔒</span> Privacy Policy
          </span>
          <button onClick={() => navigate('/')} className="text-sm font-bold text-[#ee5b2b] hover:underline">Done</button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-12 space-y-8">
        <section>
          <h2 className="text-2xl font-bold mb-4">1. Introduction</h2>
          <p className="text-gray-600 leading-relaxed">
            TableAR ("we", "our", or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our website and AR services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">2. Information We Collect</h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-600">
            <li><strong>Account Information:</strong> Name, email address, and restaurant details when you sign up.</li>
            <li><strong>Menu Data:</strong> Images, prices, and 3D models you upload.</li>
            <li><strong>Usage Data:</strong> Analytics on how many times your QR codes are scanned.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">3. How We Use Your Data</h2>
          <p className="text-gray-600 leading-relaxed">
            We use your data to provide the TableAR service, process payments, and improve our AR technology. We do not sell your personal data to third parties.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">4. Camera Access</h2>
          <p className="text-gray-600 leading-relaxed">
            Our service requires access to your device's camera to display Augmented Reality content. This camera feed is processed locally on your device and is never sent to our servers.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">5. Contact Us</h2>
          <p className="text-gray-600">
            If you have questions, please email us at <a href="https://mail.google.com/mail/?view=cm&fs=1&to=pator.explore.tech@gmail.com" target="_blank" rel="noopener noreferrer" className="text-[#ee5b2b] underline">pator.explore.tech@gmail.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;